const greatReads = {
  articles: [
    {
      id: 1,
      name: '10-Easy-Steps',
      author: '@msandfor',
      url: 'https://github.com/msandfor/10-Easy-Steps',
    },
    {
      id: 2,
      name: 'How to Contribute to Open Source',
      author: 'opensource.guide',
      url: 'https://opensource.guide/how-to-contribute/',
    },
    {
      id: 3,
      name: 'An Open Source Etiquette Guidebook',
      author: 'Kent C. Dodds and Sarah Drasner',
      url: 'https://css-tricks.com/open-source-etiquette-guidebook/',
    },
    {
      id: 4,
      name: 'An Introduction to Open Source',
      author: 'Lisa Tagliaferri',
      url:
        'https://www.digitalocean.com/community/tutorial_series/an-introduction-to-open-source',
    },
    {
      id: 5,
      name: 'The Definitive Guide to Contributing to Open Source',
      author: 'Piotr Gaczkowski',
      url:
        'https://www.freecodecamp.org/news/the-definitive-guide-to-contributing-to-open-source-900d5f9f2282/',
    },
    {
      id: 6,
      name: 'A Bitter Guide To Open Source',
      author: 'Ken Wheeler',
      url:
        'https://medium.com/codezillas/a-bitter-guide-to-open-source-a8e3b6a3c1c4',
    },
    {
      id: 7,
      name: 'How do I get started with Open Source Contributions?',
      author: 'Dinu Kumarasiri',
      url:
        'https://www.quora.com/How-do-I-get-started-with-Open-Source-Contributions/answer/Dinu-Kumarasiri',
    },
    {
      id: 8,
      name: 'First Contributions',
      author: 'First Contributions',
      url:
        'https://github.com/firstcontributions/first-contributions/blob/master/README.md',
    },
  ],
  twitterAccounts: [
    {
      id: 1,
      name: 'OpenSourceInitiative',
      handle: 'OpenSourceOrg',
      url: 'https://twitter.com/OpenSourceOrg',
    },
    {
      id: 2,
      name: 'Thomas Allmer',
      handle: 'daKmoR',
      url: 'https://twitter.com/daKmoR',
    },
    {
      id: 3,
      name: 'Sébastien Chopin',
      handle: 'Atinux',
      url: 'https://twitter.com/marcelpociot',
    },
    {
      id: 4,
      name: 'OpenSourceInitiative',
      handle: 'OpenSourceOrg',
      url: 'https://twitter.com/Atinux',
    },
    {
      id: 5,
      name: 'Facebook Open Source',
      handle: 'fbOpenSource',
      url: 'https://twitter.com/fbOpenSource',
    },
    {
      id: 6,
      name: 'Twitter Open Source',
      handle: 'TwitterOSS',
      url: 'https://twitter.com/TwitterOSS',
    },
    {
      id: 7,
      name: 'All Things Open',
      handle: 'AllThingsOpen',
      url: 'https://twitter.com/AllThingsOpen',
    },
  ],
};

export default greatReads;
